var map = {
	"./bg-aula.svg": "7961",
	"./bg-dark.png": "0649",
	"./bg-light.png": "eaa5",
	"./css/styles.css": "034b",
	"./ia.jpg": "83ab2",
	"./logo-dark.png": "b68a",
	"./logo-footer-light.svg": "0108",
	"./logo-icon-dark.png": "9977",
	"./logo-icon-light.png": "e90b",
	"./logo-light.png": "da53",
	"./logo-sesi-dark.svg": "64e1",
	"./logo-sesi-light.svg": "9f4c",
	"./lottiefiles/animation_happy": "6ede",
	"./lottiefiles/animation_happy.json": "6ede",
	"./lottiefiles/animation_sad": "445d",
	"./lottiefiles/animation_sad.json": "445d",
	"./lottiefiles/atividade": "6b81",
	"./lottiefiles/atividade.json": "6b81",
	"./lottiefiles/click_hand": "e88e",
	"./lottiefiles/click_hand.json": "e88e",
	"./lottiefiles/mao--azul": "1c03",
	"./lottiefiles/mao--azul.json": "1c03",
	"./lottiefiles/podcast": "6f20",
	"./lottiefiles/podcast.json": "6f20",
	"./lottiefiles/podcast2": "9624",
	"./lottiefiles/podcast2.json": "9624",
	"./lottiefiles/speaking": "9b55",
	"./lottiefiles/speaking.json": "9b55",
	"./modulo_01/CRLV 2024.png": "655d",
	"./modulo_01/atividades/atividade_01/atividade.png": "fd4d",
	"./modulo_01/atividades/atividade_01/infografico.png": "e020",
	"./modulo_01/atividades/atividade_01/opcaoA.png": "6846",
	"./modulo_01/atividades/atividade_01/opcaoB.png": "a30e",
	"./modulo_01/atividades/atividade_01/opcaoC.png": "43ac",
	"./modulo_01/atividades/atividade_01/opcaoD.png": "3441",
	"./modulo_01/carro1.jpg": "7f84",
	"./modulo_01/carro2.jpg": "b366",
	"./modulo_01/carro3.jpg": "33dc",
	"./modulo_01/cnh-frente.jpg": "0c96",
	"./modulo_01/cnh-verso.jpg": "8050",
	"./modulo_01/cnh.jpg": "ccfc",
	"./modulo_01/faixa0.png": "5e15",
	"./modulo_01/faixa1.png": "c2d5",
	"./modulo_01/faixa3.png": "90fa",
	"./modulo_01/flip1.png": "7a03",
	"./modulo_01/flip2.png": "cd14",
	"./modulo_01/flip3.png": "f74c",
	"./modulo_01/frase_balao-1-5.svg": "4488",
	"./modulo_01/frase_balao.svg": "9edf",
	"./modulo_01/frase_balao_2.svg": "90b3",
	"./modulo_01/frase_balao_3.svg": "dfc7",
	"./modulo_01/img2.png": "260c",
	"./modulo_01/infografico_interativo/balao_balao_1.png": "ded0",
	"./modulo_01/infografico_interativo/balao_balao_1.svg": "fbb8",
	"./modulo_01/infografico_interativo/balao_balao_2.png": "fc3c",
	"./modulo_01/infografico_interativo/balao_balao_2.svg": "0d81",
	"./modulo_01/infografico_interativo/balao_balao_3.png": "a630",
	"./modulo_01/infografico_interativo/balao_balao_3.svg": "3ad7",
	"./modulo_01/infografico_interativo/balao_balao_4.png": "88c0",
	"./modulo_01/infografico_interativo/balao_balao_4.svg": "af94",
	"./modulo_01/infografico_interativo/balao_balao_5.png": "3131",
	"./modulo_01/infografico_interativo/balao_balao_5.svg": "1904",
	"./modulo_01/infografico_interativo/balao_balao_6.png": "64af",
	"./modulo_01/infografico_interativo/balao_balao_6.svg": "4bff",
	"./modulo_01/infografico_interativo/fundo.svg": "5545",
	"./modulo_01/infografico_interativo/icone_icone_1.svg": "4dbd",
	"./modulo_01/infografico_interativo/icone_icone_2.svg": "6b04",
	"./modulo_01/infografico_interativo/icone_icone_3.svg": "1612",
	"./modulo_01/infografico_interativo/icone_icone_4.svg": "04cc",
	"./modulo_01/infografico_interativo/icone_icone_5.svg": "e407",
	"./modulo_01/infografico_interativo/icone_icone_6.svg": "49bd",
	"./modulo_01/marca1.png": "5ff9",
	"./modulo_01/marca2.png": "63be",
	"./modulo_01/marca3.jpeg": "9a5e",
	"./modulo_01/marca4.jpeg": "24f1",
	"./modulo_01/marca5.jpg": "0af3",
	"./modulo_01/personagem2.png": "4abe",
	"./modulo_01/podcasts/audio_1.mp3": "82ab",
	"./modulo_01/podcasts/audio_2.mp3": "60c2",
	"./modulo_01/podcasts/audio_3.mp3": "7e01",
	"./modulo_01/semaforo.jpeg": "ae8d",
	"./modulo_01/tipos-rodovias.png": "a359",
	"./modulo_02/Faixa-continua.png": "07f5",
	"./modulo_02/Faixas-de-transito-.png": "ca4d",
	"./modulo_02/Pinturas-no-solo.png": "fd4f",
	"./modulo_02/Pista-com-faixa-seccionada.png": "f933",
	"./modulo_02/frase_balao_4.svg": "7ecb",
	"./modulo_02/imagem1.jpg": "bd21",
	"./modulo_02/imagem2.png": "f9fa",
	"./modulo_02/imagem4.jpg": "0564",
	"./modulo_02/lfo-1.png": "b2de",
	"./modulo_02/lfo-2.png": "8c04",
	"./modulo_02/lfo-3.png": "2e34",
	"./modulo_02/lfo-4.png": "9eec",
	"./modulo_02/lms-1.png": "92b8",
	"./modulo_02/lms-2.png": "c878",
	"./modulo_02/mrf.png": "8ece",
	"./modulo_02/piramide.svg": "55d8",
	"./modulo_02/placas-transito.png": "436f",
	"./modulo_02/podcasts/audio_1.mp3": "0d1e",
	"./topico_03/frase_balao_5.svg": "4368"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";